import React from "react";

import { Collapse as AntCollapse, CollapseProps as AntCollapseProps } from "antd";

import { trackMixpanel } from "utils";

import { Icon } from "components";

export const { Panel } = AntCollapse;

type CollapseProps = Pick<AntCollapseProps, "defaultActiveKey" | "style" | "onChange" | "items" | "activeKey"> & {
  children?: React.ReactNode;
  className?: string;
};

export const Collapse = ({ className, children, defaultActiveKey, style, onChange, items, activeKey }: CollapseProps) => (
  <AntCollapse
    accordion
    className={className ?? "empty-collapse"}
    defaultActiveKey={defaultActiveKey}
    expandIcon={({ isActive }) => (isActive ? <Icon iconName="tabler/chevron-up" size="m-light" /> : <Icon iconName="tabler/chevron-down" size="m-light" />)}
    expandIconPosition="end"
    ghost
    style={style}
    activeKey={activeKey}
    onChange={(e) => {
      trackMixpanel("OpenAccordion");
      onChange?.(e);
    }}
    items={items}
  >
    {/* Children is deprecated, use items from now on */}
    {items ? null : children}
  </AntCollapse>
);
